(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var HOVER_CHANCE = 0.38;
  var PAD = 20;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function SnitchFlight(el) {
    this.el = el;
    this.boundsEl = el.closest('.hp-wizard-hero, .raffle-lp-hero') || el.offsetParent || document.documentElement;
    this.x = 0;
    this.y = 0;
    this.facing = 1;
    this.timer = null;
    this.init();
  }

  SnitchFlight.prototype.getBounds = function () {
    var boundsRect = this.boundsEl.getBoundingClientRect();
    var sizeRect = this.el.getBoundingClientRect();
    var width = boundsRect.width;
    var height = boundsRect.height;
    var w = sizeRect.width || 42;
    var h = sizeRect.height || 26;

    return {
      minX: PAD,
      minY: PAD,
      maxX: Math.max(PAD, width - w - PAD),
      maxY: Math.max(PAD, height - h - PAD)
    };
  };

  SnitchFlight.prototype.applyTransform = function (duration) {
    this.el.style.transition = 'transform ' + duration + 's cubic-bezier(0.45, 0.05, 0.3, 1)';
    this.el.style.transform =
      'translate3d(' + this.x + 'px,' + this.y + 'px,0) scaleX(' + this.facing + ')';
  };

  SnitchFlight.prototype.moveTo = function (targetX, targetY, duration) {
    var dx = targetX - this.x;
    if (Math.abs(dx) > 2) {
      this.facing = dx < 0 ? -1 : 1;
    }

    this.x = targetX;
    this.y = targetY;
    this.applyTransform(duration);
  };

  SnitchFlight.prototype.nextHop = function () {
    var bounds = this.getBounds();
    if (bounds.maxX <= bounds.minX || bounds.maxY <= bounds.minY) {
      this.timer = window.setTimeout(this.nextHop.bind(this), 600);
      return;
    }

    this.x = clamp(this.x, bounds.minX, bounds.maxX);
    this.y = clamp(this.y, bounds.minY, bounds.maxY);

    var hover = Math.random() < HOVER_CHANCE;
    var targetX;
    var targetY;
    var duration;
    var pause;

    if (hover) {
      targetX = clamp(this.x + randomBetween(-36, 36), bounds.minX, bounds.maxX);
      targetY = clamp(this.y + randomBetween(-28, 28), bounds.minY, bounds.maxY);
      duration = randomBetween(0.35, 0.95);
      pause = randomBetween(120, 520);
    } else {
      targetX = randomBetween(bounds.minX, bounds.maxX);
      targetY = randomBetween(bounds.minY, bounds.maxY);
      var distance = Math.hypot(targetX - this.x, targetY - this.y);
      duration = clamp(distance / randomBetween(90, 180), 0.55, 2.4);
      pause = randomBetween(80, 420);
    }

    this.moveTo(targetX, targetY, duration);
    this.timer = window.setTimeout(this.nextHop.bind(this), duration * 1000 + pause);
  };

  SnitchFlight.prototype.onResize = function () {
    var bounds = this.getBounds();
    this.x = clamp(this.x, bounds.minX, bounds.maxX);
    this.y = clamp(this.y, bounds.minY, bounds.maxY);
    this.applyTransform(0.3);
  };

  SnitchFlight.prototype.init = function () {
    var bounds = this.getBounds();
    this.x = randomBetween(bounds.minX, bounds.maxX);
    this.y = randomBetween(bounds.minY, bounds.maxY);
    this.el.style.transition = 'none';
    this.applyTransform(0);
    this.el.offsetHeight;
    this.nextHop();

    this._resizeHandler = this.onResize.bind(this);
    window.addEventListener('resize', this._resizeHandler, { passive: true });
  };

  SnitchFlight.prototype.destroy = function () {
    if (this.timer) window.clearTimeout(this.timer);
    window.removeEventListener('resize', this._resizeHandler);
  };

  function boot() {
    document.querySelectorAll('[data-snitch]').forEach(function (el) {
      if (el.__snitchFlight) return;
      el.__snitchFlight = new SnitchFlight(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
